import { RootState } from '@src/redux/store'
import { prop } from 'ramda'
import { createSelector } from 'reselect'

import { GLOBAL_STATE, SEMESTER_ALL } from '../constants/actionTypes'

export const semesterAllSelector = createSelector(
  (state: RootState) => prop(GLOBAL_STATE, state),
  data => data[SEMESTER_ALL]
)

export const semesterAllOptionsSelector = createSelector(semesterAllSelector, semesterAll => ({
  loading: semesterAll.loading,
  error: semesterAll.error,
  options: Array.isArray(semesterAll.data)
    ? semesterAll.data.map(item => ({ label: item.title || '', value: item.id }))
    : [],
}))
